
import { mapMutations, mapState } from 'vuex';
import VideoEmbed from '@/components/ui/videoEmbed.vue';
import WpImage from '~/components/ui/img.vue';
import RecipesCategories from '@/components/recipesCategories.vue';
import Block from '@/components/ui/block.vue';

export default {
  name: 'Recipe',

  components: {
    VideoEmbed,
    WpImage,
    RecipesCategories,
    Block,
  },

  async fetch() {
    try {
      const slug = this.$route.params.slug;
      const { data } = await this.$wp.recipes({ slug });
      if (data.length) {
        this.addRecipe(data[0]);
      } else {
        return this.$nuxt.error({ statusCode: 404 });
      }
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  computed: {
    ...mapState(['patientId']),

    recipe() {
      return this.$store.getters.getRecipe(this.$route.params.slug);
    },
    buttonText() {
      return this.$t('recipes.video');
    },
    defaultBlock() {
      return this.recipe.acf.default_blocks
        ? this.recipe.acf.default_blocks[0]
        : null;
    },
  },

  mounted() {
    this.$bolev.metaEvent({
      type: 'pageView',
      patientId: this.patientId,
    });
  },

  methods: {
    ...mapMutations(['addRecipe']),
  },

  head() {
    if (this.recipe) {
      return this.$seo.yoast(this.recipe.yoast_head_json);
    }
  },
};
